import componentKeys from "@/helpers/wc/componentKeys";

export default { [componentKeys.value]: "Text ..." };
